<template>
  <div>
    <div class="row mt-3 mb-2">
      <div class="col-sm-12">
        <div class="float-sm-end d-flex" style="justify-content: end">
          <button v-if="canCreate" type="button" class="btn btn-success btn-rounded mb-2 mr-2" @click="newTask()">
            <i class="mdi mdi-plus mr-1"></i> Nova ação
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="table-responsive">
          <table class="table table-centered table-hover">
            <thead>
              <tr>
                <th width="20%">Data</th>
                <th width="35%">Tarefa</th>
                <th width="20%">Bloqueio aplicado</th>
                <th width="10%">Lista</th>
                <th width="10%">Status</th>
                <th>#</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!tasks.length">
                <td colspan="6" class="text-center text-muted py-4">Nenhuma ação registrada.</td>
              </tr>
              <tr v-for="list in tasks" :key="list.id">
                <td>{{ list.created_at }}</td>
                <td>{{ list.name }}</td>
                <td>
                  <span class="badge badge-info font-size-12 p-2">
                    {{ list.target_flight_block_name || ('#' + list.target_flight_block_id) }}
                  </span>
                </td>
                <td>{{ list.type_contact }} ({{ list.qty_contacts }})</td>
                <td>
                  <span :class="list.classStatus" class="badge font-size-12 p-2" style="min-width: 120px">
                    {{ list.statusLabel }}
                  </span>
                </td>
                <td>
                  <button v-if="user.role === 'Admin'" type="button" @click="detailLog(list.id)" class="link btn btn-outline-primary btn-sm"><i class="bx bx-search"></i></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row">
          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-right">
              <ul class="pagination pagination-rounded mb-0">
                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" @input="updateList"></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-form ref="formFlightBlock" @created="updateList"></modal-form>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import ModalForm from './Form'

export default {
  components: { ModalForm },
  data () {
    return {
      loading: true,
      timeout: null,
      params: {},
      currentPage: 1,
      perPage: 10
    }
  },
  mounted () {
    this.updateList()
    this.timeout = setInterval(() => {
      this.updateList()
    }, 10000)
  },
  beforeDestroy () {
    clearInterval(this.timeout)
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('taskFlightBlock', ['tasks', 'pagination']),
    ...mapGetters('auth', ['hasPermission', 'isSuperAdmin']),
    rows () {
      return this.pagination.total || 0
    },
    canCreate () {
      return this.isSuperAdmin || this.hasPermission('flight-blocks.bulk-apply')
    }
  },
  methods: {
    ...mapActions('taskFlightBlock', { getAll: 'getAll' }),
    newTask () {
      this.$refs.formFlightBlock.open()
    },
    detailLog (id) {
      if (this.user.role === 'Admin') {
        this.$router.push({ name: 'task-flight-block-details', params: { id: id } })
      }
    },
    getReport () {
      const params = { limit: this.perPage, page: this.currentPage }
      this.params = params
      const loader = this.$loading.show()
      this.getAll(this.params).then(() => {
        loader.hide()
      }).catch(err => {
        loader.hide()
        console.error(err)
      })
    },
    updateList () {
      this.getReport()
    }
  }
}
</script>
<style scoped>
.float-sm-end { float: right }
</style>
